// Helpers compartilhados pelos sub-componentes de Comercial / Propostas.
// Extraído de ComercialPropostas.tsx durante refactor topológico.
import { fetchAuthSession } from 'aws-amplify/auth';
import { fmtDataBr as _fmtDataBr } from '../../utils/dataFmt';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

export const fmtDate = _fmtDataBr;

// Aceita number OU string (Postgres numeric vira string em node-pg).
// Antes só number, e quando recebia string a chamada virava
// String.prototype.toLocaleString() — que IGNORA o options e devolve a
// string crua tipo "14336.15406000000000000000000". Bug clássico.
export const fmtR = (v: number | string | null | undefined) => {
  const n = typeof v === 'number' ? v : parseFloat(String(v ?? '0'));
  if (!Number.isFinite(n)) return 'R$ 0,00';
  return 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
